<script setup lang="ts">
import { EStoreModules } from '@/store/storeType'
import {
    BaseDialog,
    NumberInputField,
    StackLayout,
    StringInputField
} from '@rfc/rfc-components-library'
import { useCreateModel } from '@rfc/rfc-components-library/hooks'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { PRODUCTS_ROUTES } from '../../../router/routes'
import { EProductActions } from '../../../store/productStore/ProductStoreTypes'
import { ERouteId } from '../../../types/enum/RouteIdEnum'
import type { ProductCreateModel } from '../../../types/models/ProductModel'
import ProductTemplateSelectors from '../../../views/ProductsView/components/ProductTemplateSelectors.vue'

const store = useStore()
const router = useRouter()

type Props = {
    open: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'close'): void
    (e: 'refresh'): void
}
defineEmits<Emits>()

const createError = ref<string>()

const createProduct = useCreateModel<ProductCreateModel>({
    store,
    stateKey: EStoreModules.PRODUCT,
    stateAction: EProductActions.CREATE_PRODUCT,
    router,
    routeIdKey: ERouteId.PRODUCTS_ID,
    routeGoTo: PRODUCTS_ROUTES.baseUrl
})
</script>

<template>
    <BaseDialog
        :open="open"
        @close="$emit('close')"
        @confirm="createProduct.createData"
        :loading="createProduct.loading.value"
        :title="$t('customers.create')"
        :disabled="!createProduct.data?.value?.product_id || !createProduct.data?.value?.name">
        <template #content>
            <StackLayout direction="column">
                <v-alert v-if="createError" type="error" class="mb-4">
                    {{ createError }}
                </v-alert>
                <NumberInputField
                    :modelValue="createProduct.data.value.product_id"
                    @change="createProduct.handleUpdateValue({ product_id: $event })"
                    :label="$t('customers.model.customerId')"
                    required />
                <StringInputField
                    :modelValue="createProduct.data.value.name"
                    @change="createProduct.handleUpdateValue({ name: $event })"
                    :label="$t('customers.model.name')"
                    required />
                <ProductTemplateSelectors
                    :data="createProduct.data.value"
                    @change="createProduct.handleUpdateValue({ ...$event })" />
            </StackLayout>
        </template>
    </BaseDialog>
</template>
